import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

/**
 * Hook to set the page name (title) for a given page, displayed in the header.
 */
const useSetPageName = (titleKey: string): void => {
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()

  const title = t(titleKey)

  useEffect(() => {
    dispatch(appUpdate({ title }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title])
}

export default useSetPageName
